import { useEffect, useState } from 'react'
import { smText } from '../../../style/text'
import { fetchCode, fetchFolderContents, fetchToken } from '../../../api/api'
import { useSiteData } from '../../../context/fetchContext'

const Token = ({
  setStage,
  setToken,
  setLoading,
  setFullGalleryData
}: any) => {

  const [error, setError] = useState<string>('')
  const [code, setCode] = useState('')

  const handleSubmit = async () => {
    setLoading(true)
    if (!code) {
      setError('This field cannot be empty')
    } else {
      const tokenResponse = await fetchToken(code)
      if (!tokenResponse || tokenResponse.data?.error) {
        setError("Invalid code")
      } else {
        const websiteFolderId = '31212251375'
        const newToken = tokenResponse.data.access_token
        const folderResponse = await fetchFolderContents(newToken, websiteFolderId)

        if (!folderResponse || folderResponse?.data.error) {
          setError('Folder Id has been changed or deleted. Talk to your developer')
          setLoading(false)
          return
        }

        const rootFolders = folderResponse.data.metadata
        // Map folder list to gallery items with files
        const galleryFoldersWithFiles = await Promise.all(
          rootFolders.contents.map(async (f: any) => {
            if (f.isfolder) {
              const folderResponse = await fetchFolderContents(newToken, f.folderid)
              if (folderResponse) {
                const filesList = folderResponse.data.metadata
                const files = (filesList.contents ?? []).filter(({ isfolder }: any) => !isfolder)

                return {
                  ...f,
                  files,
                }
              }
            }
          })
        )
        //FIXME - check

        // Remove null/undefined entries
        const validGalleryFolders = galleryFoldersWithFiles.filter(Boolean)

        setFullGalleryData(validGalleryFolders)

        setToken(newToken)
        setStage('manage')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchCode()
  }, [])

  return (
    <div className='w-[400px] flex flex-col gap-4'>
      <p className={`${smText} font-medium`}>Access Code</p>
      <div>
        {
          error ? (
            <label htmlFor="token" className='flex gap-1 text-red-600 opacity-70' >
              <p >{error}*</p>
            </label>
          ) : (
            <div className='h-[24px]'></div>
          )
        }
        <input
          onChange={(e) => {
            setCode(e.target.value)
            setError('')
          }}
          value={code}
          type="text"
          name='token'
          className='border w-full border-1 focus:outline-none p-1 my-2'
          style={{
            borderColor: error ? '#f87171' : '#000000',
            color: error ? '#f87171' : '#000000'
          }}
        />
      </div>
      <div className='flex gap-3'>
        <button
          className='bg-black text-white p-3'
          onClick={() => fetchCode()}
        >
          Resend
        </button>
        <button
          className='bg-black text-white p-3'
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  )
}

export default Token